module.exports = __webpack_public_path__ + "static/media/analytics_2.c7db0a55.png";